export default [
  {
    path: "/performance",
    name: "performance",
    component: () => import(/* webpackChunkName: "performance" */ "@/views/performance/PerformanceView.vue"),
    meta: { rights: ["g_performance"], navbarTitle: "Performance", hideLogo: true,
      showBackButton: true, backTo: "/", hideBottomNavigation: true },
  },
]
